import React from "react";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Typography } from "@material-ui/core";

export default function Loader(props) {
  return (
    <Container>
      <Typography variant="h5" style={{ marginBottom: 15 }}>
        Medilink
      </Typography>
      <Typography style={{ marginBottom: 15 }}>
        {props.message || null}
      </Typography>
      <CircularProgress size={50} />
    </Container>
  );
}

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  flex-direction: column;
`;
